import type { IconProps } from './types'

export const RBLogoIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="48 29 64 19"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <polyline points="74.1,43.8 48.9,43.8 48.9,47.3 75.1,47.3 95.3,34 109.4,43.3 111.3,40.4 95.3,29.8 74.1,43.8" fill="#FFF" />
    </svg>
  )
}
